import { format } from "date-fns";

interface DateTimeCellProps {
  /** Primary date (formatted as "MMM d, yyyy") */
  date: Date;
  /** Optional secondary time display (formatted as "h:mm a") */
  time?: Date | null;
}

/**
 * Shared table cell for date + time display
 * Shows the date on the first line, and optional time below in muted text
 */
export function DateTimeCell({ date, time }: DateTimeCellProps) {
  return (
    <div className="flex flex-col">
      <span className="font-medium">{format(date, "MMM d, yyyy")}</span>
      {time && (
        <span className="text-xs text-muted-foreground">
          {format(time, "h:mm a")}
        </span>
      )}
    </div>
  );
}
